(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["links-visual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tgf-links-hub')) {
  customElements.define('tgf-links-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.menu = this.querySelector('[data-menu]');
      this.summary = this.menu.querySelector('summary');
      this.panel = this.querySelector('.lc-menu-panel');
      this.background = Array.from(this.querySelectorAll('[data-lc-background]'));
      const rail = this.querySelector('[data-rail]');
      const next = this.querySelector('[data-next]');
      const search = this.querySelector('[data-search]');
      const categoryLinks = Array.from(this.querySelectorAll('[data-menu-category]'));
      const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      next.hidden = false;
      this.querySelector('[data-search-wrap]').hidden = false;
      const updateRail = () => { next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 3; };
      next.addEventListener('click', () => {
        rail.scrollBy({ left: rail.clientWidth * .78, behavior: reducedMotion() ? 'instant' : 'smooth' });
      }, options);
      rail.addEventListener('scroll', updateRail, { ...options, passive: true });
      window.addEventListener('resize', updateRail, options);
      updateRail();
      this.menu.addEventListener('toggle', () => {
        const open = this.menu.open;
        this.background.forEach(element => { element.inert = open; });
        this.summary.setAttribute('aria-expanded', String(open));
        if (open) {
          this.panel.setAttribute('role', 'dialog');
          this.panel.setAttribute('aria-modal', 'true');
          this.panel.querySelector('[data-close]').focus({ preventScroll: true });
        } else {
          this.panel.removeAttribute('role');
          this.panel.removeAttribute('aria-modal');
        }
      }, options);
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.closeMenu(), options));
      this.menu.addEventListener('keydown', event => {
        if (!this.menu.open) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeMenu();
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.panel.querySelectorAll('a[href],button,input')).filter(element => !element.hidden && !element.disabled && element.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);
      const normalize = value => value.toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').trim();
      search.addEventListener('input', () => {
        const query = normalize(search.value);
        let matches = 0;
        categoryLinks.forEach(link => {
          link.hidden = !normalize(link.textContent).includes(query);
          if (!link.hidden) matches++;
        });
        this.querySelector('[data-search-empty]').hidden = matches > 0;
      }, options);
      let startX = 0, startY = 0;
      this.panel.addEventListener('touchstart', event => {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { ...options, passive: true });
      this.panel.addEventListener('touchend', event => {
        const point = event.changedTouches[0];
        if (point && startX - point.clientX > 90 && Math.abs(startY - point.clientY) < 60) this.closeMenu();
      }, { ...options, passive: true });
    }
    closeMenu() {
      this.menu.open = false;
      this.background.forEach(element => { element.inert = false; });
      this.summary.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.background?.forEach(element => { element.inert = false; });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgf-category-rail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tgf-category-rail')) {
  customElements.define('tgf-category-rail', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      const rail = this.querySelector('[data-track]');
      const controls = this.querySelector('[data-controls]');
      const previous = this.querySelector('[data-previous]');
      const next = this.querySelector('[data-next]');
      if (!rail || !controls || !previous || !next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const sync = () => {
        const distance = Math.abs(rail.scrollLeft);
        const maximum = rail.scrollWidth - rail.clientWidth;
        controls.hidden = maximum <= 4;
        previous.disabled = distance <= 3;
        next.disabled = distance >= maximum - 3;
      };
      const move = step => {
        const direction = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
        rail.scrollBy({
          left: rail.clientWidth * .8 * step * direction,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      rail.addEventListener('scroll', sync, { ...options, passive: true });
      this.observer = new ResizeObserver(sync);
      this.observer.observe(rail);
      sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgf-set-builder"]) return;
  try {
    
  if (!customElements.get('tgf-set-builder')) {
    customElements.define('tgf-set-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-set-config]').textContent);
        this.text = this.config.text;
        this.form = this.querySelector('form');
        this.cards = [...this.querySelectorAll('[data-set-card]')];
        this.submit = this.querySelector('[type="submit"]');
        this.status = this.querySelector('[data-set-status]');
        this.ready = false;
        this.busy = false;
        this.uncertain = false;
        this.guide = this.querySelector('[data-size-guide]');
        this.querySelectorAll('[data-guide-open]').forEach(button => button.addEventListener('click', () => {
          this.querySelectorAll('[data-guide-panel]').forEach(panel => {
            panel.hidden = panel.dataset.guidePanel !== button.dataset.guideOpen;
            if (!panel.hidden) this.querySelector('[data-guide-title]').textContent = panel.dataset.guideLabel;
          });
          this.guideOpener = button;
          this.guideOverflow = document.body.style.overflow;
          this.guide.showModal();
          this.guide.scrollTop = 0;
          document.body.style.overflow = 'hidden';
          this.querySelector('[data-guide-close]').focus({preventScroll:true});
        }));
        this.querySelector('[data-guide-close]').addEventListener('click', () => this.guide.close());
        this.guide.addEventListener('click', event => {
          const rect = this.guide.getBoundingClientRect();
          if (event.target === this.guide && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.guide.close();
        });
        this.guide.addEventListener('close', () => this.restoreGuide());
        this.form.addEventListener('change', event => this.changed(event));
        this.form.addEventListener('input', event => {
          event.target.setCustomValidity?.('');
          event.target.removeAttribute('aria-invalid');
          if (event.target.matches('[data-tag-name],[data-tag-phone]')) event.target.dataset.edited = 'true';
          if (event.target.matches('[data-set-name],[data-set-phone]')) this.syncTagFields();
          if (this.status.classList.contains('is-error') && !this.uncertain) {
            this.status.classList.remove('is-error');
            this.render();
          }
        });
        this.form.addEventListener('submit', event => { event.preventDefault(); this.add(); });
        this.querySelector('[data-set-retry]').addEventListener('click', () => this.refresh());
        this.render();
        this.refresh();
      }
      restoreGuide() {
        if (this.guideOverflow !== undefined) document.body.style.overflow = this.guideOverflow;
        this.guideOverflow = undefined;
        if (this.guideOpener?.isConnected) this.guideOpener.focus({preventScroll:true});
      }
      disconnectedCallback() {
        if (this.guide?.open) this.guide.close();
        this.restoreGuide();
      }
      get selected() { return this.cards.filter(card => card.querySelector('[data-set-pick]').checked); }
      format(value) { return new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style:'currency', currency:this.config.currency }).format(value / 100); }
      discount(items) {
        const units = items.filter(item => item.eligible).flatMap(item => Array(item.quantity).fill(item.price)).sort((a,b) => a-b);
        return units.slice(0, Math.floor(units.length/2)).reduce((sum,price) => sum + Math.round(price/2), 0);
      }
      syncTagFields() {
        for (const key of ['name','phone']) {
          const field = this.querySelector(`[data-tag-${key}]`);
          if (field && field.dataset.edited !== 'true') field.value = this.querySelector(`[data-set-${key}]`).value;
        }
      }
      changed(event) {
        event.target.setCustomValidity?.('');
        event.target.removeAttribute('aria-invalid');
        const card = event.target.closest('[data-set-card]');
        if (card) {
          const checked = card.querySelector('[data-set-pick]').checked;
          const options = card.querySelector('[data-set-options]');
          options.hidden = !checked;
          options.disabled = !checked;
          card.querySelector('[data-pick-label]').textContent = checked ? this.text.chosen : this.text.choose;
          const width = card.querySelector('[data-set-width]');
          if (width && event.target.matches('[data-set-size]')) {
            const widths = { XSMALL:['1cm','1.5cm'], SMALL:['1.5cm','2cm'], MEDIUM:['2cm','2.5cm'], LARGE:['2.5cm'] }[event.target.value] || [];
            width.replaceChildren(new Option(this.text.select,''), ...widths.map(value => new Option(value,value)));
            width.disabled = widths.length === 0;
            card.querySelector('[data-width-wrap]').hidden = widths.length === 0;
            if (widths.length === 1) width.value = widths[0];
          }
        }
        this.syncTagFields();
        this.status.classList.remove('is-error');
        this.render();
      }
      signature(config) { return JSON.stringify([config.currency,config.products,config.cart]); }
      async snapshot() {
        const url = new URL(location.href);
        url.searchParams.set('section_id',this.dataset.section);
        const response = await fetch(url, { credentials:'same-origin', cache:'no-store', headers:{Accept:'text/html'} });
        if (!response.ok) throw new Error('snapshot');
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        const data = html.querySelector('[data-set-config]');
        if (!data) throw new Error('snapshot');
        return JSON.parse(data.textContent);
      }
      async refresh() {
        if (this.busy || this.uncertain) return;
        this.ready = false;
        this.status.textContent = this.text.loading;
        this.submit.disabled = true;
        this.querySelector('[data-set-retry]').hidden = true;
        try {
          this.config = await this.snapshot();
          this.ready = this.config.currency === 'TRY';
          this.render();
          if (!this.ready) this.status.textContent = this.text.currency;
        } catch (_) {
          this.status.textContent = this.text.load_error;
          this.querySelector('[data-set-retry]').hidden = false;
        }
      }
      render() {
        for (const card of this.cards) {
          const product = this.config.products.find(item => item.handle === card.dataset.handle);
          const checkbox = card.querySelector('[data-set-pick]');
          checkbox.disabled = !product?.available;
          if (checkbox.disabled) checkbox.checked = false;
          const options = card.querySelector('[data-set-options]');
          options.hidden = !checkbox.checked;
          options.disabled = !checkbox.checked;
          card.querySelector('[data-pick-label]').textContent = checkbox.disabled ? this.text.sold_out : checkbox.checked ? this.text.chosen : this.text.choose;
          card.querySelector('[data-item-price]').textContent = this.format(product?.price || 0);
        }
        const allItems = this.config.products.filter(item => item.available).map(item => ({price:item.price,quantity:1,eligible:true}));
        this.querySelector('[data-full-saving]').textContent = this.text.full_saving_template.replace('[amount]',this.format(this.discount(allItems)));
        const modes = this.selected.map(card => card.querySelector('[data-set-mode]')?.value);
        this.querySelector('[data-set-name]').required = modes.some(mode => mode === 'name' || mode === 'phone');
        this.querySelector('[data-set-phone]').required = modes.includes('phone');
        for (const key of ['name','phone']) {
          const field = this.querySelector(`[data-set-${key}]`);
          if (!field.required) { field.setCustomValidity(''); field.removeAttribute('aria-invalid'); }
        }
        const selected = this.selected.map(card => this.config.products.find(item => item.handle === card.dataset.handle));
        this.querySelector('[data-selected-count]').textContent = this.text.selected_count.replace('[count]',selected.length);
        const addedItems = selected.map(item => ({price:item.price,quantity:1,eligible:true}));
        const selectionSubtotal = selected.reduce((sum,item) => sum+item.price,0);
        const selectionTotal = this.format(selectionSubtotal-this.discount(addedItems));
        this.querySelector('[data-selection-total]').textContent = selectionTotal;
        this.querySelector('[data-set-submit-total]').textContent = selectionTotal;
        const discount = this.discount([...this.config.cart.items,...addedItems]);
        const currentCartSubtotal = this.config.cart.items.reduce((sum,item) => sum + item.price * item.quantity,0);
        const subtotal = currentCartSubtotal + selected.reduce((sum,item) => sum+item.price,0);
        this.projected = subtotal-discount;
        const storedItems = this.config.cart.items.map(item => ({...item,price:item.storedPrice ?? item.price}));
        const modelCart = this.config.cart.original-this.discount(storedItems);
        this.otherDiscount = modelCart !== this.config.cart.total;
        this.querySelector('[data-coupon]').hidden = !this.otherDiscount;
        if (!this.uncertain) this.status.textContent = !this.ready ? this.text.loading : '';
        this.submit.disabled = !this.ready || this.busy || this.uncertain;
      }
      productionSku(card) {
        const kind = card.dataset.kind;
        const base = (this.config.products.find(item => item.handle === card.dataset.handle)?.sku || '').trim();
        const prefixes = {collar:'P',h:'PH',easy:'PE',leash:'PG',handsfree:'HF',tag:'TFS'};
        if (!prefixes[kind] || !new RegExp(`^${prefixes[kind]}[0-9]+$`).test(base)) throw new Error('sku');
        if (kind === 'leash' || kind === 'handsfree' || kind === 'tag') return base;
        const size = card.querySelector('[data-set-size]')?.value;
        const suffix = {XSMALL:'XS',SMALL:'S',MEDIUM:'M',LARGE:'L'}[size];
        if (!suffix) throw new Error('size');
        if (kind === 'easy') return base + suffix;
        const width = card.querySelector('[data-set-width]')?.value;
        const widths = {XSMALL:['1cm','1.5cm'],SMALL:['1.5cm','2cm'],MEDIUM:['2cm','2.5cm'],LARGE:['2.5cm']};
        if (!widths[size].includes(width)) throw new Error('width');
        return base + suffix + (widths[size].indexOf(width) === 1 ? '+' : '');
      }
      properties(card,group) {
        if (card.dataset.kind === 'tag') {
          const properties = {
            '_tgf_set_id':group,
            'Set':this.dataset.pattern,
            'Üretim SKU':this.productionSku(card),
            'Lütfen Boy Seçiniz':card.querySelector('[data-set-size]').value,
            'Dostunuzun adı?':card.querySelector('[data-tag-name]').value.trim(),
            'Mesajınız?':card.querySelector('[data-tag-message]').value.trim(),
            'Telefon Numaranız?':card.querySelector('[data-tag-phone]').value.trim()
          };
          if (!properties['Mesajınız?']) properties['Mesaj tercihi'] = 'Mesaj yazılmasın';
          return properties;
        }
        const mode = card.querySelector('[data-set-mode]').value;
        const properties = { '_tgf_set_id':group, 'Set':this.dataset.pattern, 'Üretim SKU':this.productionSku(card), 'Kişiselleştirme':mode === 'blank' ? 'Boş kalsın' : mode === 'name' ? 'Sadece isim' : 'İsim + telefon' };
        const size = card.querySelector('[data-set-size]')?.value;
        if (size) properties['Lütfen Boy Seçiniz'] = size;
        const width = card.querySelector('[data-set-width]')?.value;
        if (width) properties[`${size} Tasmanızın kalınlığı kaç cm olsun?`] = width;
        if (mode !== 'blank') properties['Dostunuzun adı?'] = this.querySelector('[data-set-name]').value.trim();
        if (mode === 'phone' && card.dataset.kind !== 'handsfree') properties['Telefon Numaranız?'] = this.querySelector('[data-set-phone]').value.trim();
        if (mode === 'phone' && card.dataset.kind === 'handsfree') properties['Kişiselleştirme'] = 'Sadece isim';
        return properties;
      }
      showError(message,field) {
        this.status.textContent = message;
        this.status.classList.add('is-error');
        if (field) {
          field.setAttribute('aria-invalid','true');
          field.scrollIntoView({block:'center',behavior:'auto'});
          field.focus({preventScroll:true});
        }
      }
      validate() {
        for (const field of this.form.querySelectorAll('[aria-invalid]')) field.removeAttribute('aria-invalid');
        if (this.selected.length === 0) { this.showError(this.text.minimum); return false; }
        const name = this.querySelector('[data-set-name]');
        const phone = this.querySelector('[data-set-phone]');
        name.setCustomValidity(name.required && !name.value.trim() ? this.text.name_invalid : '');
        const validPhone = /^\+?[\d\s().-]+$/.test(phone.value.trim()) && /^[0-9]{10,15}$/.test(phone.value.replace(/\D/g,''));
        phone.setCustomValidity(phone.required && !validPhone ? this.text.phone_invalid : '');
        const tagPhone = this.querySelector('[data-tag-phone]');
        if (tagPhone) {
          const value = tagPhone.value.trim();
          const valid = !value || (/^\+?[\d\s().-]+$/.test(value) && /^[0-9]{10,15}$/.test(value.replace(/\D/g,'')));
          tagPhone.setCustomValidity(valid ? '' : this.text.phone_invalid);
        }
        const invalid = [...this.form.querySelectorAll('input,select')].find(field => field.willValidate && !field.validity.valid);
        if (invalid) {
          const card = invalid.closest('[data-set-card]');
          const label = (invalid.labels?.[0]?.textContent.trim() || '').replace(/[?.:]+$/,'');
          const message = invalid === name ? this.text.name_invalid : invalid === phone || invalid === tagPhone ? this.text.phone_invalid : `${card?.querySelector('.tgf-set__card-name').textContent || ''}: ${label}. ${this.text.complete_fields}`;
          this.showError(message,invalid);
          return false;
        }
        return true;
      }
      async add() {
        if (this.busy || !this.ready || this.uncertain) return;
        if (!this.validate()) return;
        this.status.classList.remove('is-error');
        this.status.textContent = this.text.adding;
        this.busy = true;
        this.querySelector('.tgf-set__body').inert = true;
        this.submit.disabled = true;
        this.querySelector('[data-set-submit-label]').textContent = this.text.adding;
        const signature = this.signature(this.config);
        let submitted = false;
        try {
          const group = `tgf-${crypto.randomUUID()}`;
          const items = this.selected.map(card => ({id:this.config.products.find(item => item.handle === card.dataset.handle).id,quantity:1,properties:this.properties(card,group)}));
          const fresh = await this.snapshot();
          if (this.signature(fresh) !== signature) {
            this.config = fresh;
            this.busy = false;
            this.render();
            this.showError(this.text.cart_changed);
            return;
          }
          submitted = true;
          const response = await fetch(`${this.config.root.replace(/\/$/,'')}/cart/add.js`, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          if (!response.ok) throw new Error('add');
          const verify = await fetch(`${this.config.root.replace(/\/$/,'')}/cart.js`, {credentials:'same-origin',cache:'no-store'});
          if (!verify.ok) throw new Error('verify');
          const cart = await verify.json();
          if (cart.items.filter(item => item.properties?._tgf_set_id === group).reduce((sum,item)=>sum+item.quantity,0) !== items.length) throw new Error('partial');
          location.assign(this.config.cartUrl);
        } catch (_) {
          this.ready = false;
          this.uncertain = submitted;
          this.showError(submitted ? this.text.add_error : this.text.load_error);
          this.querySelector('[data-set-cart]').hidden = !submitted;
          this.querySelector('[data-set-retry]').hidden = submitted;
        } finally {
          this.busy = false;
          this.querySelector('.tgf-set__body').inert = false;
          this.querySelector('[data-set-submit-label]').textContent = this.text.add;
          this.submit.disabled = !this.ready || this.uncertain;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
